import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';

import {catchError} from 'rxjs/operators';

@Injectable()
export class ApiService {

  headers: any;

  constructor(
    private readonly http: HttpClient
  ) {
    this.headers = new HttpHeaders();
    this.headers.append('Accept', 'application/json');
  }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams({})): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, {params})
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      body,
      {headers: this.headers}
    ).pipe(catchError(this.formatErrors));
  }

  post(path: string, body = {}): Observable<any> {
    return this.http.post(
      `${environment.api_url}${path}`,
      body,
      {headers: this.headers}
    ).pipe(catchError(this.formatErrors));
  }

  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`
    ).pipe(catchError(this.formatErrors));
  }

  upload(path, formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    return this.http.post(
      `${environment.api_url}${path}`,
      formData,
      {
        headers
      }
    ).pipe(catchError(this.formatErrors));
  }

}
